/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Request8 { 
    id?: number;
    productInfoId?: number;
    storeId?: number;
    organizationId?: number;
    amount?: number;
    forSale?: boolean;
    onlineSellable?: boolean;
    minOrderDay?: number;
    untilOrderTime?: string;
    receiveAfterTime?: string;
}

